import React from "react";
import { CloudUpload, DriveFileRenameOutline, FileDownload } from "@mui/icons-material";
import { Box } from "@mui/material";

import { getCurrentProject } from "fond/project";
import { useAppSelector } from "fond/utils/hooks";
import { Actions, permissionCheck } from "fond/utils/permissions";
import { StackedNavigationButton, useStackedNavigationContext } from "fond/widgets";
import StackedNavigationHeader from "fond/widgets/StackedNavigation/StackedNavigationHeader";

interface LayerPanelProps {
  title: string;
  layerKey: string;
  testIdPrefix?: string;
}

const LayerPanel: React.FC<LayerPanelProps> = ({ title, layerKey, testIdPrefix }) => {
  const { open, clear } = useStackedNavigationContext();
  const project = useAppSelector((state) => getCurrentProject(state.project));
  const canViewExport = permissionCheck(project?.Permission?.Level, Actions.PROJECT_EXPORT_VIEW);
  const testPrefix = testIdPrefix || layerKey;

  const handleOnDrawButtonClick = () => {
    open(`${layerKey}-draw`);
  };

  const handleOnUploadPolygon = () => {
    open(`${layerKey}-upload`);
  };

  const handleOnExportLayer = () => {
    open(`${layerKey}-export`);
  };

  const onBack = () => {
    clear();
  };

  return (
    <Box>
      <StackedNavigationHeader title={title} onBackButtonClick={onBack} />
      <StackedNavigationButton
        data-testid={`draw-${testPrefix}-button`}
        icon={<DriveFileRenameOutline />}
        title="Draw"
        subtitle="Add and edit data on the map"
        onClick={handleOnDrawButtonClick}
      />
      <StackedNavigationButton
        data-testid={`upload-${testPrefix}-button`}
        icon={<CloudUpload />}
        title="Upload"
        subtitle="Use my data"
        onClick={handleOnUploadPolygon}
      />
      {canViewExport && (
        <StackedNavigationButton
          data-testid={`export-${testPrefix}-button`}
          icon={<FileDownload />}
          title="Export Layer"
          subtitle="Download layer data"
          onClick={handleOnExportLayer}
        />
      )}
    </Box>
  );
};

export default LayerPanel;
